import { DataProvider } from "react-admin";
import { BookingDataProvider } from "./bookingProvider";
import { UserDataProvider } from "./userProvider";
import { PropertyDataProvider } from "./propertyProvider";
import { ProviderDataProvider } from "./providerProvider";

// Create instances of each provider
const bookingProvider = new BookingDataProvider();
const userProvider = new UserDataProvider();
const propertyProvider = new PropertyDataProvider();
const providerProvider = new ProviderDataProvider();

// Main data provider that routes to appropriate sub-providers
export const dataProvider: DataProvider = {
  getList: async (resource, params) => {
    switch (resource) {
      case "bookings":
        return bookingProvider.getList(resource, params);
      case "users":
        return userProvider.getList(resource, params);
      case "properties":
        return propertyProvider.getList(resource, params);
      case "providers":
        return providerProvider.getList(resource, params);
      default:
        throw new Error(`Unknown resource: ${resource}`);
    }
  },

  getOne: async (resource, params) => {
    switch (resource) {
      case "bookings":
        return bookingProvider.getOne(resource, params);
      case "users":
        return userProvider.getOne(resource, params);
      case "properties":
        return propertyProvider.getOne(resource, params);
      case "providers":
        return providerProvider.getOne(resource, params);
      default:
        throw new Error(`Unknown resource: ${resource}`);
    }
  },

  getMany: async (resource, params) => {
    switch (resource) {
      case "bookings":
        return bookingProvider.getMany(resource, params);
      case "users":
        return userProvider.getMany(resource, params);
      case "properties":
        return propertyProvider.getMany(resource, params);
      case "providers":
        return providerProvider.getMany(resource, params);
      default:
        throw new Error(`Unknown resource: ${resource}`);
    }
  },

  getManyReference: async (resource, params) => {
    switch (resource) {
      case "bookings":
        return bookingProvider.getManyReference(resource, params);
      case "users":
        return userProvider.getManyReference(resource, params);
      case "properties":
        return propertyProvider.getManyReference(resource, params);
      case "providers":
        return providerProvider.getManyReference(resource, params);
      default:
        throw new Error(`Unknown resource: ${resource}`);
    }
  },

  create: async (resource, params) => {
    switch (resource) {
      case "bookings":
        return bookingProvider.create(resource, params);
      case "users":
        return userProvider.create(resource, params);
      case "properties":
        return propertyProvider.create(resource, params);
      case "providers":
        return providerProvider.create(resource, params);
      default:
        throw new Error(`Unknown resource: ${resource}`);
    }
  },

  update: async (resource, params) => {
    switch (resource) {
      case "bookings":
        return bookingProvider.update(resource, params);
      case "users":
        return userProvider.update(resource, params);
      case "properties":
        return propertyProvider.update(resource, params);
      case "providers":
        return providerProvider.update(resource, params);
      default:
        throw new Error(`Unknown resource: ${resource}`);
    }
  },

  updateMany: async (resource, params) => {
    switch (resource) {
      case "bookings":
        return bookingProvider.updateMany(resource, params);
      case "users":
        return userProvider.updateMany(resource, params);
      case "properties":
        return propertyProvider.updateMany(resource, params);
      case "providers":
        return providerProvider.updateMany(resource, params);
      default:
        throw new Error(`Unknown resource: ${resource}`);
    }
  },

  delete: async (resource, params) => {
    switch (resource) {
      case "bookings":
        return bookingProvider.delete(resource, params);
      case "users":
        return userProvider.delete(resource, params);
      case "properties":
        return propertyProvider.delete(resource, params);
      case "providers":
        return providerProvider.delete(resource, params);
      default:
        throw new Error(`Unknown resource: ${resource}`);
    }
  },

  deleteMany: async (resource, params) => {
    switch (resource) {
      case "bookings":
        return bookingProvider.deleteMany(resource, params);
      case "users":
        return userProvider.deleteMany(resource, params);
      case "properties":
        return propertyProvider.deleteMany(resource, params);
      case "providers":
        return providerProvider.deleteMany(resource, params);
      default:
        throw new Error(`Unknown resource: ${resource}`);
    }
  },
};
